<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace" id="epi"> </p>
<p class="ep">The waters become hard like stone, and the face of the deep is frozen.</p>
<p class="ep"> </p>
<p class="ep"><span class="epub-sc">JOB</span> 38:30</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?a58c7528